export default (theme) => ({
  root: {
    width: '100%',
    height: '500px',
  },
  dangerHeading: {
    backgroundColor: 'red',
  },
  dangerText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: '900',
    color: '#fff',
  },

  alertHeading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    backgroundColor: '#EAAB36',
    color: '#fff',
  },

  alertText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: '900',
  },

  nameHeading: {
    width: '100%',
  },
});
